import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el producto después de comprar?',
  a: 'Inmediatamente después de tu pago recibís un mail con el acceso a todos los tomos y bonos en formato PDF digital. En menos de 5 minutos ya podés estar leyendo el Tomo 1.'
}, {
  q: '¿Sirve si soy jugador nuevo o es solo para avanzados?',
  a: 'El Rugby Pro Kit está diseñado para jugadores amateurs y semiprofesionales que quieren mejorar su nivel. Si jugás en club y querés dar el salto, es para vos.'
}, {
  q: '¿Necesito instalaciones especiales o me alcanza con mi club?',
  a: 'Todo el contenido está adaptado a la realidad del rugby de club argentino. Sin instalaciones de alto rendimiento ni cuerpo técnico costoso.'
}, {
  q: '¿Los 6 bonos están incluidos en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en el Rugby Pro Kit y en el Rugby Pro Kit Élite. La diferencia es que el Élite suma los 2 manuales especializados del N°9 y el N°10.'
}, {
  q: '¿Sirve si juego en el interior del país?',
  a: 'Sí. El contenido está pensado para el rugby argentino en general: URBA, UAR provincial e Interior. Todo adaptado a la realidad del jugador de club.'
}, {
  q: '¿Qué diferencia tiene con los videos gratuitos de YouTube?',
  a: 'Los videos de YouTube son tips sueltos sin estructura. El Rugby Pro Kit es un sistema completo y progresivo adaptado al rugby argentino, con planificación anual, táctica específica y herramientas listas para aplicar.'
}, {
  q: '¿Por qué elegir el Rugby Pro Kit Élite y no el estándar?',
  a: 'Por $8.000 pesos más tenés los dos manuales de las posiciones más buscadas por los DT argentinos. Menos que una salida el sábado a la noche. Y puede cambiarte la carrera.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% sin preguntas ni formularios.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-24 bg-rugby-green-950 relative" data-id="element-173">
      <div className="container mx-auto px-4" data-id="element-174">
        <div className="max-w-3xl mx-auto" data-id="element-175">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-16" data-id="element-176">
            <span className="text-rugby-gold-400 font-bold tracking-widest uppercase text-xs md:text-sm mb-2 block" data-id="element-177">
              Dudas Comunes
            </span>
            <h2 className="text-3xl md:text-5xl font-display text-white" data-id="element-178">
              PREGUNTAS FRECUENTES
            </h2>
          </motion.div>

          <div className="space-y-2.5 md:space-y-4" data-id="element-179">
            {faqs.map((faq, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className={`bg-rugby-green-900 border rounded-xl overflow-hidden transition-colors ${openIndex === i ? 'border-rugby-gold-500/60' : 'border-rugby-green-700'}`} data-id="element-180">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 md:p-6 text-left focus:outline-none" data-id="element-181">
                  <span className="font-bold text-white pr-6 md:pr-8 text-sm md:text-base" data-id="element-182">
                    {faq.q}
                  </span>
                  <ChevronDown size={18} className={`text-rugby-gold-500 flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-183" />
                </button>
                <AnimatePresence data-id="element-184">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-185">
                      <div className="px-4 pb-4 md:px-6 md:pb-6 pt-2 text-sm md:text-base text-slate-300 leading-relaxed border-t border-rugby-green-800/50" data-id="element-186">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}